function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { ALIGN_TYPES } from "constants/align-types";
import { lineDistance } from "utils/math";
import UniverseStars from "segments/desktop/core-components/universe-stars/universe-stars";
import classnames from "classnames";
import { SPACE_BLUE_GRADIANT_THEME_ID } from "segments/segments-service";
import SquareTagsGridComponent from "segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-component";
import { useCompanyData } from "client/services/enrichment/company-data";
import { isBigCompany } from "client/services/enrichment/clearbit-selectors";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import { CONTACT_SALES_FROM_TAGS_PAGE_LINK } from "constants/links";
import { shouldSeeEnrichmentHomepageSalesCtaAbTest } from "services/ab-tests/acquisition-ab-test-service";
import { withAbTests } from "contexts/ab-tests-context";
import PALETTE_SCHEMES from "segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/palette-schemes";
import Title from "segments/desktop/core-components/title/title";
import DefaultProps from "./default-props";
import { StyledMondayUniverseHomepageFirstFoldComponent } from "./monday-universe-homepage-first-fold-component.scss";
import { stars } from "./stars-clusters-config";
const Stars = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx(UniverseStars, {
        stars: stars
    });
});
const MondayUniverseHomepageFirstFoldComponent = (props)=>{
    const companyData = useCompanyData();
    const { fullParagraph, subTitle, subTitleAdvancedConfig, fullParagraphAdvancedConfig, buttonConfig, clusters, theme, abTests, translate, tagsWidth, pallet, squareTagsMarginTop, showBorderInLightTheme, randomizeTags } = props;
    const paletteScheme = useMemo(()=>PALETTE_SCHEMES[pallet] || {}, [
        pallet
    ]);
    const renderLines = ()=>{
        const { lines } = props;
        return lines.map((line, index)=>{
            var _line_start, _line_start1, _line_end, _line_end1;
            const lineStart = {
                top: parseInt(line === null || line === void 0 ? void 0 : (_line_start = line.start) === null || _line_start === void 0 ? void 0 : _line_start.top),
                left: parseInt(line === null || line === void 0 ? void 0 : (_line_start1 = line.start) === null || _line_start1 === void 0 ? void 0 : _line_start1.left)
            };
            const lineEnd = {
                top: parseInt(line === null || line === void 0 ? void 0 : (_line_end = line.end) === null || _line_end === void 0 ? void 0 : _line_end.top),
                left: parseInt(line === null || line === void 0 ? void 0 : (_line_end1 = line.end) === null || _line_end1 === void 0 ? void 0 : _line_end1.left)
            };
            if (!Number.isInteger(lineStart.top) || !Number.isInteger(lineStart.left) || !Number.isInteger(lineEnd.top) || !Number.isInteger(lineEnd.left)) {
                return null;
            }
            const angle = Math.atan2(lineEnd.top - lineStart.top, lineEnd.left - lineStart.left) * 180 / Math.PI;
            const distance = lineDistance(lineStart.left, lineStart.top, lineEnd.left, lineEnd.top);
            return /*#__PURE__*/ _jsx("div", {
                className: classnames("comet-line", {
                    underline: true
                }),
                style: _object_spread({
                    transform: `rotate(${angle}deg)`,
                    width: distance
                }, lineStart)
            }, `comet-${index}`);
        });
    };
    const isUniverseTheme = theme === SPACE_BLUE_GRADIANT_THEME_ID;
    const shouldShowSecondaryButton = useMemo(()=>{
        return isBigCompany(companyData) && shouldSeeEnrichmentHomepageSalesCtaAbTest(abTests, true);
    }, [
        companyData,
        abTests
    ]);
    const squareTagsProps = {
        tagsWidth,
        buttonConfig,
        clusters,
        theme,
        secondaryButtonConfig: shouldShowSecondaryButton ? {
            buttonText: translate("signup.talkToSales"),
            color: WHITE_COLOR_NAME,
            url: CONTACT_SALES_FROM_TAGS_PAGE_LINK,
            isOpenLinkInNewTab: true
        } : null,
        marginTop: squareTagsMarginTop,
        showBorderInLightTheme,
        randomizeTags
    };
    return /*#__PURE__*/ _jsxs(StyledMondayUniverseHomepageFirstFoldComponent, {
        className: classnames("monday-universe-homepage-first-fold-component", {
            "selectable-clusters": true,
            "universe-theme": isUniverseTheme
        }),
        children: [
            isUniverseTheme && /*#__PURE__*/ _jsxs("div", {
                className: "stars-canvas",
                children: [
                    renderLines(),
                    /*#__PURE__*/ _jsx(Stars, {})
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("paragraph-wrapper"),
                children: [
                    /*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, fullParagraphAdvancedConfig, fullParagraph), {
                        topic: {},
                        textAlign: ALIGN_TYPES.CENTER,
                        titleClassName: "universe-title"
                    })),
                    (subTitle === null || subTitle === void 0 ? void 0 : subTitle.title) && /*#__PURE__*/ _jsx(Title, _object_spread_props(_object_spread({}, subTitle, subTitleAdvancedConfig), {
                        titleClassName: "sub-title"
                    }))
                ]
            }),
            /*#__PURE__*/ _jsx(SquareTagsGridComponent, _object_spread({
                palette: paletteScheme
            }, squareTagsProps))
        ]
    });
};
const MondayUniverseHomepageFirstFoldComponentWithAbTests = withAbTests(MondayUniverseHomepageFirstFoldComponent);
MondayUniverseHomepageFirstFoldComponentWithAbTests.defaultProps = DefaultProps;
export default MondayUniverseHomepageFirstFoldComponentWithAbTests;
